import { create } from "zustand";
import { TPlatformAdmin } from "../types";

interface AuthState {
  admin: TPlatformAdmin | null;
  token: string | null;
  setAuth: (admin: TPlatformAdmin, token: string) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  admin: null,
  token: localStorage.getItem("platform_token"),
  setAuth: (admin, token) => {
    localStorage.setItem("platform_token", token);
    set({ admin, token });
  },
  clearAuth: () => {
    localStorage.clear();
    set({ admin: null, token: null });
  },
}));
